import PropTypes from 'prop-types';
import React from 'react';

import Image from 'components/ImageV2';
import Label from 'components/Label';
import { SubBold } from 'components/Sub';
import { IMAGE_BG_COLOR } from 'constants/images';
import Theme from 'styles/theme';
import I18n from 'utils/I18n';

const ProductCard = ({ product, currentVariant, imageSize }) => {
  const price = currentVariant?.formattedPrice;
  const compareAtPrice = currentVariant?.formattedCompareAtPrice;
  const isFinalSale = currentVariant?.isFinalSale;
  const size = currentVariant?.value;
  const imageUrl = product?.collectionProductCardImage?.src;
  const imageAlt = product?.collectionProductCardImage?.alt;
  const name = product?.masterName;
  const color = product?.colorName;
  const url = product?.url;

  return (
    <div className="ATCProductCard">
      <a className="ATCProductCard__left" href={url}>
        <Image
          src={imageUrl}
          alt={imageAlt}
          width={imageSize}
          height={imageSize}
          transformations={{ devicePixelRatio: 2 }}
          coverParentNode
        />
      </a>
      <div className="ATCProductCard__right">
        <SubBold className="ATCProductCard__details--text">{name}</SubBold>
        <Label className="ATCProductCard__details--text">{color}</Label>
        {size && (
          <Label className="ATCProductCard__details--text">
            {I18n.localize('cart.lineItem.size')}: {size}
          </Label>
        )}
        {!compareAtPrice ? (
          <Label className="ATCProductCard__details--text">{price}</Label>
        ) : (
          <div className="ATCProductCard__details--sale-price">
            <Label className="ATCProductCard__details--price">{price}</Label>
            <Label className="ATCProductCard__details--compare-at-price">{compareAtPrice}</Label>
            {isFinalSale && (
              <Label className="ATCProductCard__details--final-sale">
                {I18n.localize('cart.finalSaleMessage')}
              </Label>
            )}
          </div>
        )}
      </div>
      <style jsx global>
        {`
          .ATCProductCard {
            display: flex;
            width: 100%;
          }

          .ATCProductCard__left {
            max-width: ${imageSize / 2}px;
            min-width: ${imageSize / 2}px;
            margin-right: ${Theme.get('spacing') * 2}px;
            background-color: ${IMAGE_BG_COLOR};
          }

          .ATCProductCard__right {
            text-wrap: wrap;
            vertical-align: top;
          }

          .Sub.ATCProductCard__details--text,
          .ATCProductCard__details--text.Label {
            margin-bottom: ${Theme.get('spacing') / 2}px;
            display: block;
          }

          .ATCProductCard__details--compare-at-price.Label {
            text-decoration: line-through;
          }

          .ATCProductCard__details--price.Label {
            margin-right: ${Theme.get('spacing')}px;
            color: ${Theme.get('colors-discount-red')};
          }

          .ATCProductCard__details--final-sale.Label {
            color: ${Theme.get('colors-discount-red')};
            display: block;
          }
        `}
      </style>
    </div>
  );
};

ProductCard.propTypes = {
  product: PropTypes.shape({
    collectionProductCardImage: PropTypes.shape({
      src: PropTypes.string.isRequired,
      alt: PropTypes.string.isRequired,
    }).isRequired,
    masterName: PropTypes.string.isRequired,
    colorName: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
  }).isRequired,
  currentVariant: PropTypes.shape({
    formattedPrice: PropTypes.string.isRequired,
    formattedCompareAtPrice: PropTypes.string,
    isFinalSale: PropTypes.bool.isRequired,
    value: PropTypes.string.isRequired,
  }),
  imageSize: PropTypes.number.isRequired,
};

ProductCard.defaultProps = {
  currentVariant: null,
};
export default ProductCard;
